import {Component, Input, OnInit} from '@angular/core';
import {DownloadFileService} from 'app/global/download-file.service';
import {RoleDetail} from '../../signing-page/signing-page.dto';
import {DocumentsTabService} from './documents-tab.service';
import { PermissionsService } from 'app/global/permissions/permissions.service';
import { PermissionsEnum } from 'app/global/permissions/permissions.enum';
import { of } from 'rxjs';
import { SingingPageService } from '../../signing-page/signing-page-service';
import { RefreshFileService } from '../../helpers/refresh-file.service';
import { GlobalService } from 'app/global/global.service';
import { TranslocoService } from '@jsverse/transloco';
import { SigningStatusEnum } from '../../enums/enum';

@Component({
  selector: 'app-documents-tab',
  templateUrl: './documents-tab.component.html',
  styleUrl: './documents-tab.component.scss'
})
export class DocumentsTabComponent implements OnInit {

  @Input() roleId: number;
  @Input() document_id: number;
  @Input() is_sender: number;
  @Input() roleDetail: RoleDetail;

  constructor(
    private documentsTabService:DocumentsTabService, 
    private downloadFile:DownloadFileService, 
    private _permissionService: PermissionsService,
    private signingPageService: SingingPageService,
    private refreshFileService: RefreshFileService,
    private globalService: GlobalService,
    private translocoService: TranslocoService
  ){}
  public downloading:boolean = false;
  public canDownloadDocument$ = of(true);
  public uploadedFiles = [];
  public downloadingFileId: number = null;
  public uploadFileLoader: boolean = false;

  ngOnInit(): void {
    if(this.is_sender){
      this.canDownloadDocument$ = this._permissionService.isNotRestricted(PermissionsEnum.restrict_access_download_sent_documents);
    }
    this.getUploadedFiles();
  }

  getUploadedFiles(){
    this.signingPageService.getUploadedFiles(this.roleId).subscribe({
      next: async (files) => {
        this.uploadedFiles = files;
      }
    })  
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];
    const allowedTypes = [
      'image/jpeg', 'image/png', 'image/jpg',
      'text/csv', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/pdf', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      'text/plain'
    ];

    if (!allowedTypes.includes(file.type)) {
      this.globalService.toastrError(this.translocoService.translate('Document tab upload file error text (Document tab) - Please upload a valid file type'));
      return;
    }

    this.uploadFileLoader = true;
    const formData = new FormData();
    formData.append('file', file);

    this.signingPageService.uploadedFile(this.roleId, formData).subscribe({
      next: async (file) => {
        this.uploadFileLoader = false;
        this.uploadedFiles.push(file);
        this.globalService.toastrSuccess(this.translocoService.translate('Document tab upload file success text (Document tab) - Your file is uploaded successfully'));
      },
      error: (error) => {
        this.uploadFileLoader = false;
        this.globalService.toastrError(error);
      }
    })  
  }

  downloadUploadedFile(filePath: string, fileName: string, fileId: number){
    this.downloadingFileId = fileId;
    this.refreshFileService.refreshImage(filePath, this.roleId, this.roleDetail?.roleable?.id, false).subscribe({
          next: (pdfUrlBlob:Blob) => {
              this.downloadingFileId = null;
              if(pdfUrlBlob){
                const lastDotIndex = fileName.lastIndexOf('.');
                const name = lastDotIndex === -1 ? fileName : fileName.substring(0, lastDotIndex);
                const extensionIndex = filePath.lastIndexOf('.');
                const extension = extensionIndex === -1 ? '' : filePath.substring(extensionIndex + 1);
                this.downloadFile.downloadAdditionaFile(pdfUrlBlob, name, extension);
              }
          },
          error: () => {
            this.downloadingFileId = null;
          }
      });
  }

  /**
   * download the document pdf
   */
  async downloadPdf(){
    this.downloading = true;
    if ((this.roleDetail?.roleable?.status === SigningStatusEnum.UPLOADED || this.roleDetail?.roleable?.is_uploaded) && this.roleDetail?.uploaded_pdf) {
      this.refreshFileService.refreshImage(this.roleDetail?.uploaded_pdf, this.roleId, this.roleDetail?.roleable?.id, false).subscribe({
          next: (pdfUrlBlob:Blob) => {
              this.downloading = false;
              if(pdfUrlBlob){
                const uploaded_file = this.roleDetail?.uploaded_pdf;
                const fileName = this.roleDetail?.roleable?.visible_name ?? this.roleDetail?.roleable.name;
                const fileExtension = uploaded_file.substring(uploaded_file.lastIndexOf('.') + 1).toLowerCase();
                this.downloadFile.downloadAdditionaFile(pdfUrlBlob, fileName, fileExtension);
              }
          },
          error: (error) => {
            this.globalService.toastrError(error);
            this.downloading = false;
          }
      });
    } else {
      this.documentsTabService.generatePdf(this.roleId).subscribe({
        next: async (blob:Blob) => {
          this.downloadFile.downloadFile(blob, this.roleDetail?.roleable?.visible_name ?? this.roleDetail?.roleable?.name);
          this.downloading = false;
        },
        error: (error) => {
          this.downloading = false;
          this.globalService.toastrError(error);
        }
      })  
    }
  }
}
